export function fixedHeader() {
    document.addEventListener('scroll', function (e) {
        if (window.scrollY > 50) {
            document.querySelector('header').classList.add('hader-fixed');
        } else {
            document.querySelector('header').classList.remove('hader-fixed');
        }
    });
}